<template>
    <!--About One Start-->
    <section class="about-one">
            <div class="about-one__shape-box-1">
                <div class="about-one__shape-1"
                    style="background-image: url(assets/images/shapes/about-one-shape-1.png);">
                </div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <div class="about-one__left">
                            <div class="about-one__img-box wow slideInLeft" data-wow-delay="100ms"
                                data-wow-duration="2500ms">
                                <div class="about-one__img">
                                    <img src="assets/images/homeFotos/trabajos2-2.jpeg" alt="">
                                </div>
                                <div class="about-one__img-border"></div>
                                <!-- <div class="about-one__curved-circle-box">
                                    <div class="curved-circle">
                                        <span class="curved-circle--item">
                                            25 YEARS EXPERIENCE OXPINS CHARITY CENTER
                                        </span>
                                    </div> img con texto circular tipo moneda
                                    <div class="about-one__curved-circle-icon">
                                        <img src="assets/images/icon/curved-circle-icon.png" alt="">
                                    </div>
                                </div> -->
                                <!--div class="about-one__shape-2 zoom-fade">
                                    <img src="assets/images/shapes/about-one-shape-2.png" alt="">
                                </div>
                                <div class="about-one__shape-3 float-bob-y">
                                    <img src="assets/images/shapes/about-one-shape-3.png" alt="">
                                </div>
                                <div class="about-one__shape-4 zoominout">
                                    <img src="assets/images/shapes/about-one-shape-4.png" alt="">
                                </div-->
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
    <div class="about-one__right">
        <div class="section-title text-left">
            <h2 class="section-title__title">Sobre Nosotros</h2>
        </div>

        <p class="about-one__text justifi">
            Fundada en 2016, Ingeniería Eléctrica e Hidráulica SpA se especializa en el montaje y reparación de sistemas eléctricos e hidráulicos, tanto en entornos residenciales como industriales. Nuestro compromiso es ofrecer soluciones integrales que satisfagan las necesidades de nuestros clientes, garantizando calidad, eficiencia y seguridad en cada proyecto.
        </p>

        <p class="about-one__text tx-p justifi">
            Somos una empresa orientada a la prestación de servicios, cuyo objetivo principal es brindar soluciones efectivas que aporten beneficios reales y duraderos. Acompañamos a nuestros clientes en cada etapa del proyecto: desde la planificación hasta la instalación y el mantenimiento.
        </p>

        <p class="about-one__text justifi">
            Ejecutamos proyectos eléctricos e hidráulicos completos, asegurando un servicio técnico profesional que detecta, resuelve y previene posibles fallas, manteniendo siempre altos estándares de calidad y seguridad.
        </p>

        <p class="about-one__text justifi" style="margin-top: 20px;">
            En IEH trabajamos con compromiso, responsabilidad y profesionalismo, atendiendo tanto a clientes particulares como a empresas. Nuestro equipo está preparado para ofrecer asesoría y presupuestos sin compromiso.
        </p>
    </div>
</div>

                </div>

                <div class="row">
    <div class="col-12">

        <p class="about-one__text justifi" style="margin-top: 20px;">
            Con el propósito de mejorar la calidad y eficiencia de nuestros servicios, hemos incorporado tecnología de telemetría, un sistema que permite la adquisición y transmisión automática de datos desde ubicaciones remotas hacia centros de control. Esto se logra mediante sensores que recopilan información y la envían a través de redes inalámbricas u otros medios de comunicación para su monitoreo en tiempo real.
        </p>

        <p class="about-one__text tx-p justifi">
            La telemetría facilita la toma de decisiones informadas al proporcionar datos precisos y oportunos. Además, permite almacenar información para análisis futuros, optimizando procesos, reduciendo tiempos de servicio y mejorando la eficiencia operativa.
        </p>

        <p class="about-one__text justifi">
            Este sistema es aplicable en diversos sectores industriales y agrícolas, donde se monitorean variables como presión, temperatura y humedad. En la agricultura, por ejemplo, permite optimizar sistemas de riego y alimentación de cultivos, logrando una gestión más eficiente y sostenible.
        </p>

        <p class="about-one__text tx-p justifi">
            Entre nuestros principales servicios eléctricos e hidráulicos se encuentran:
        </p>

        <ul class="about-one__text justifi" style="margin-bottom:20px;">
            <li>Instalaciones y montajes eléctricos en media y baja tensión</li>
            <li>Mantenimientos y reparaciones eléctricas</li>
            <li>Diseño y fabricación de tableros de fuerza y control</li>
            <li>Extracción e instalación de bombas de pozo profundo</li>
            <li>Pruebas de bombeo</li>
            <li>Sistemas de impulsión de agua</li>
            <li>Sistemas de riego tecnificado</li>
            <li>Mantenimiento de equipos de bombeo</li>
        </ul>

        <router-link to="/contact">
            <a href="#" class="thm-btn about-one__btn tx-p">Contáctanos</a>
        </router-link>

    </div>
</div>

            </div>
        </section>
        <!--About One End-->

</template>
    <style>
        .tx-p{
            margin-top: 20px;
            margin-bottom: 20px;
        }

        .justifi{
            text-align: justify;
        }

        .about-one{
            padding: 120px 0 40px !important;
        }

        @media only screen and (max-width: 1024px){
            .about-one__shape-box-1 {
                width: 508px;
            }
        }

        @media only screen and (max-width: 768px){
            .about-one {
                padding: 60px 0 40px !important;
            }

            .about-one__shape-box-1{
                height: 591px;
                width: 382px;
            }
            .about-one__img-border{

                height: 458px;
                width: 331px;   
                border: 4px solid var(--oxpins-primary);
            }
        }

        @media only screen and (max-width: 375px){
            .about-one__shape-box-1 {
                height: 490px;
            }
        }

        @media only screen and (max-width: 320px){
            .about-one__shape-box-1 {
                height: 494px;
            }
        }
        
  </style>
<script>
</script>